<template>
  <finance-shell v-if="restaurantId" />
  <div v-else class="pa-6">
    <page-header icon="mdi-finance" :title="$t('finance_page_title')" :subtitle="$t('please_select_restaurant_to_view_data')" />
  </div>
</template>

<script>
import PageHeader from "@/components/global/PageHeader.vue";
import FinanceShell from "@/components/finance-shell/FinanceShell.vue";

/**
 * Finansije (/restaurant/finance): Zarada, Obračuni, Transakcije i Ugovor i cijene. Isti izgled kao izvještaji, magacin
 * i recepti (gornja navigacija, zajednička traka perioda, detalji u desnom panelu), isti raspored na telefonu.
 * Stanje (tab, period, prikaz transakcija) je u adresi.
 */
export default {
  name: "RestaurantFinance",
  components: { PageHeader, FinanceShell },
  computed: {
    restaurantId() {
      const restaurant = this.$store.state.restaurant;
      return restaurant ? restaurant.id : null;
    },
  },
};
</script>
